// Firebase configuration for the React app
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCzm-XQZSx8CWzQ8a8d_FUHJyLxGeTntYw",
  authDomain: "draftsimulatorapp.firebaseapp.com",
  projectId: "draftsimulatorapp",
  storageBucket: "draftsimulatorapp.appspot.com",
  messagingSenderId: "1043835478071",
  appId: "1:1043835478071:web:be5bee89f19496a2205fb2",
  measurementId: "G-506N49ENV7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);

// Initialize Google provider
const googleProvider = new GoogleAuthProvider();

// Export all initialized services
export { auth, db, onAuthStateChanged, googleProvider };
export default app; 